<div class="view-container">
   <div *ngIf="stale" class="history-stale">Session History may be stale — waiting for a successful refresh.</div>

   <as-split class="split" direction="horizontal" [gutterSize]="5">

      <!-- LEFT: sessions per terminal (active session pinned on top) -->
      <as-split-area order="0" [size]="historyListSectionSize">
         <ag-grid-angular class="ag-theme-balham-dark" style="width: 100%; height: 100%;"
            [gridOptions]="sessionsGridOptions"></ag-grid-angular>
      </as-split-area>

      <!-- MIDDLE: Portfolio -> Combo -> Group roll-ups -->
      <as-split-area order="1" [size]="sessionBucketsListSectionSize">
         <as-split direction="vertical" [gutterSize]="5">
            <as-split-area [order]="0" [size]="bucketSectionSize">
               <ag-grid-angular class="ag-theme-balham-dark" style="width: 100%; height: 100%;"
                  [gridOptions]="portfoliosGridOptions"></ag-grid-angular>
            </as-split-area>
            <as-split-area [order]="1" [size]="bucketSectionSize">
               <ag-grid-angular class="ag-theme-balham-dark" style="width: 100%; height: 100%;"
                  [gridOptions]="combosGridOptions"></ag-grid-angular>
            </as-split-area>
            <as-split-area [order]="2" [size]="bucketSectionSize">
               <ag-grid-angular class="ag-theme-balham-dark" style="width: 100%; height: 100%;"
                  [gridOptions]="groupsGridOptions"></ag-grid-angular>
            </as-split-area>
         </as-split>
      </as-split-area>

      <!-- FAR-RIGHT: item snapshots (top) + flat ledger (bottom) -->
      <as-split-area order="2" [size]="sessionDetailsSectionSize">
         <as-split direction="vertical" [gutterSize]="5">
            <as-split-area [order]="0" [size]="itemsSectionSize">
               <ag-grid-angular class="ag-theme-balham-dark" style="width: 100%; height: 100%;"
                  [gridOptions]="itemsGridOptions"></ag-grid-angular>
            </as-split-area>
            <as-split-area [order]="1" [size]="ledgerSectionSize">
               <ag-grid-angular class="ag-theme-balham-dark" style="width: 100%; height: 100%;"
                  [gridOptions]="ledgerGridOptions"></ag-grid-angular>
            </as-split-area>
         </as-split>
      </as-split-area>

   </as-split>

</div>
